import {
	config
} from '@/config.js'
import {
	getWxLogin,
	getZfbLogin,
	getCurrentPageUrl,
	getStorageSyncWithExpiration
} from '@/utils/index.js'

//不需要校验是否有token的接口
const noRouter = [
	'/api/user/login',
	'/api/user/wxLoginMini',
	'/api/user/zfbLoginMini',
	'/api/merchant/homeCate',
	'/api/merchant/list',
	'/api/banner/list',
];

// 全局请求封装
const base_url = config.apiUrl;
let nums = 0;

// 需要修改token，和根据实际修改请求头
export default async (params) => {
	if (getApp().globalData.showGuide) return
	let url = params.url;
	let loading = params.loading;
	let method = params.method || "get";
	let data = params.data || {};
	let header = {}
	header = {
		'content-type': 'application/json; charset=UTF-8'
	};
	// 同步获取本地token
	let token = getStorageSyncWithExpiration("token");
	// header['Authorization'] = 'Bearer ' + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhZG1pbiIsImlhdCI6MTc1NzY2MTU4OSwiZXhwIjoxNzU4MjY2Mzg5LCJkYXRhIjp7InVzZXJfaWQiOjE2ODAxfX0.kjF0zyptaDJeGC9IvexjsMBApWonBF2aFrJ7I1EG-LU';
	if (token) {
		header['Authorization'] = 'Bearer ' + token
	}
	// console.log('header', header)
	return new Promise((resolve, reject) => {

		if (!loading && loading != false) {
			getApp().globalData.reqNum++;

			if (getApp().globalData.reqNum == 1) {
				nums = 0
				uni.showLoading({
					title: '加载中',
					mask: true //请求中，不允许用户点击
				});
			}
		}

		uni.request({
			url: base_url + url,
			method: method,
			header: header,
			data: data,
			success(response) {
				const res = response.data;

				// 根据返回的状态码做出对应的操作
				switch (res.code) {
					case 401:

						uni.showModal({
							title: '提示',
							content: '未登录或登录过期，请先登录',
							showCancel: false,
							success: function (res) {
								if (res.confirm) {
									uni.reLaunch({
										url: '/pages/login/login'
									});
								}
							}
						});

						uni.removeStorageSync('token')

						break;
					case 200:
						resolve(res);
						break;
					case 801:
						resolve(res);
						break;
					default:
						if (res.code === 500 && res.msg === '请求参数缺token') {
							isWxZfb(res.code)
						} else if (res.msg) {
							nums = 2000
							uni.showToast({
								icon: 'none',
								title: res.msg,
								duration: 2000, // 设置持续时间为3秒
							});
						}
						resolve(res);
						break;
				}
			},
			fail(err) {
				console.log('err', err)
				if (err.errMsg.indexOf('request:fail') !== -1) {
					uni.showToast({
						title: '网络异常',
						icon: "error",
						duration: 2000
					})
				} else {
					uni.showToast({
						title: '未知异常',
						duration: 2000
					})
				}
				reject(err);
			},
			complete() {
				if (!loading && loading != false) {
					getApp().globalData.reqNum--;
					if (getApp().globalData.reqNum <= 0) {
						setTimeout(() => {
							uni.hideLoading({ noConflict: true });
						}, nums)
					}
				}
			}
		});
	})
};


//判断是支付打开还是微信打开还是浏览器打开
export function isWxZfb(code) {
	let token = getStorageSyncWithExpiration("token");
	if (!token) {
		//只有第一次且没有token且在微信端打开









		console.log('当前环境为H5');
		if (code) {
			uni.showModal({
				title: "提示",
				content: token ? errorCode[code] : '你还没登录，请登录',
				showCancel: false,
				success(res) {
					if (res.confirm) {
						console.log(window.location);
						uni.setStorageSync("token", '');
						uni.reLaunch({
							url: '/pages/login/login'
						});
					} else if (res.cancel) {
						uni.reLaunch({
							url: '/pages/index/index'
						});
					}
				}
			})

			return true
		}

	}

	return false
}